import React, { Component } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import MessageBox from "../components/MessageBox";
import ChatBox from "../components/ChatBox"
import ChatControls from "../components/ChatControls"
export default class Chat extends Component {
    render() {
        return (
            <Container maxWidth="lg">
                <Box my={5}>
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        alignContent="center"
                        wrap="nowrap"
                    >
                        <Typography variant="h2" color="primary">
                            Chat Messages
                        </Typography>
                    </Grid>
                    <Box my={5}>
                        <MessageBox />
                    </Box>
                    <Box my={5}>
                        <ChatBox />
                    </Box>
                    <Box my={5}>
                        <ChatControls />
                    </Box>
                </Box>
            </Container>
        )
    }
}
